// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDnZ7r_jKNtCTm8vUnnt1kVfXZsPtCtJ-E",
  authDomain: "my-edu-23fce.firebaseapp.com",
  projectId: "my-edu-23fce",
  storageBucket: "my-edu-23fce.firebasestorage.app",
  messagingSenderId: "549482019839",
  appId: "1:549482019839:web:1f173e92df0725f64b05ca",
  measurementId: "G-7C2F77PWJ4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { analytics, auth, db };
